<div class="media">
  <div class="media-body align-self-center">
    <ngb-progressbar
      [value]="score"
      [max]="100"
      height="12px"
    padding="0">
    </ngb-progressbar>
  </div>
  <div class="ml-3 align-self-center nunito text-progress-bar">
    {{(score > 0) ? score : 0}}%
  </div>
</div>
